<template>
  <div>
    <Header
      :isactive='2'
      :ischunrk='true'
      :isfixed='isFixed'
      :key=" new Date().getTime()"
    />
    <div id="banner">
      <!-- {background:'url('+require('@/assets/image/banner-about.jpg')+')'} -->
      <img
        src="@/assets/image/banner-about.jpg"
        alt=""
      >
    </div>
    <div
      id="second-nav"
      class="fixed-yes'"
    >
      <div class="nav-content overflow">
        <a
          class="nav-item first active left"
          @click=" goto(542)"
        >公司简介</a>
        <a
          class="nav-item left"
          @click=" goto(1010)"
        >愿景与使命</a>
        <a
          class="nav-item left"
          @click=" goto(1410)"
        >发展历程</a>
        <a
          class="nav-item left"
          @click=" goto(2675)"
        >公司架构</a>
        <!--        <a
                  class="nav-item left"
                  @click=" goto(3300)"
                >管理团队</a>-->
        <a
          class="nav-item left"
          @click=" goto(4040)"
        >企业价值观</a>
        <a
          class="nav-item left"
          @click=" goto(4730)"
        >合作伙伴</a>
      </div>
    </div>
    <div id="company-introduce">
      <div class="introduce-content">
        <div class="title-content">
          <p class="trans">XI’AN YOUWO KEHUA INFORMATION TECHNOLOGY CO.LTD</p>
          <p class="title">西安优我科华视觉科技有限公司</p>
        </div>
        <div class="text-content">
          <p class="text">
            西安优我科华视觉科技有限公司（简称“优我科华视觉”）注册成立于2017年8月，是一家领先以机器视觉为核心，深耕于智能制造行业。目前主要业务方向为3大部分：1 汽车制造业 2.液晶面板制造业 3.火车检测类。
          </p>
          <p class="text">
            优我科华视觉目前已与包括汽车制造业的车架总成在线检测系统，为国内唯一，主要客户包括东风本田，陕重汽，中国一汽，中国汽车工程有限公司，中国一汽。在汽车涂胶质量检测项目中，完全击败日本基恩士产品，被武汉东风本田一厂采用。液晶面板类,核心技术有3块：1高精度视觉定位，最高精度可达1μm。2.自动AOI粒子检测机，3.PCB
            Check 印刷电路板检测机，这三部分竞争对手均为日本以及韩国厂商。目前主要客户有京东方、华星光电、彩虹光电。以及部分台湾企业。
          </p>
          <p class="text">
            西安优我科华视觉科技有限公司，一直秉承做好用的机器视觉产品，对产品的要求绝不仅仅是停留在能用层面，而是坚信好用的产品才能获得更坚固的客户关系。故一直在技术层面优化，目前公司不仅在传统的机器视觉算法上保持领先地位，而人工智能方面已经开始研发无监管式人工智能，更好的应用于人眼难以企及的缺陷检测。</p>
        </div>
      </div>
    </div>
    <div
      id="company-vision"
      class="overflow"
    >
      <img
        class="bg-vision"
        src="@/assets/image/bg-vision.jpg"
        alt=""
      >
      <ul class="vision-content overflow">
        <li class="li-icon left"></li>
        <li class="li-title left">
          <p class="trans">VISION AND MISSION</p>
          <p class="title">愿景与使命</p>
        </li>
        <li class="li-desc left">
          <p class="title">成为领先的机器视觉产品与服务企业</p>
          <p class="desc">我们的使命“整合互联网信息和技术，为客户创造价值”</p>
          <p class="desc">2025年，为5000万用户提供有价值的产品和服务</p>
          <p class="desc">2025年，为2000家企业提供营销产品、50000开发者提供增值服务</p>
          <p class="desc">2025年，提供1000个就业岗位</p>
        </li>
      </ul>
    </div>
    <div id="develop">
      <div class="de-content">
        <div class="title-content">
          <p class="trans">Development history</p>
          <p class="title">发展历程</p>
        </div>
        <ul class="time-list">
          <li class="time-item overflow">
            <div class="year left">2017</div>
            <div class="thing-list left">
              <div class="thing-item">
                <div class="point"></div>
                <p class="title">08月04日</p>
                <p class="desc">西安优我科华视觉科技有限公司成立</p>
              </div>
            </div>
          </li>
          <li class="time-item overflow">
            <div class="year left">2018</div>
            <div class="thing-list left">
              <div class="thing-item">
                <div class="point"></div>
                <p class="title">09月01日</p>
                <p class="desc">建立YWJC视觉检测框架，同年获得东风本田，陕重汽合作供应商</p>
              </div>
            </div>
          </li>
          <li class="time-item overflow">
            <div class="year left">2019</div>
            <div class="thing-list left">
              <div class="thing-item">
                <div class="point"></div>
                <p class="title">07月30日</p>
                <p class="desc">建立YWDC视觉检测框架，进入冠捷显示科技，中电九天的合作供应商名录。</p>
              </div>
            </div>
          </li>
          <li class="time-item overflow">
            <div class="year left">2020</div>
            <div class="thing-list left">
              <div class="thing-item">
                <div class="point"></div>
                <p class="title">01月21日</p>
                <p class="desc">
                  获得国家级高新技术企业，中国创新创业大赛，省决赛第7名，经济日报创业企业观察点，获得中国工业工程汽车有限公司，彩虹光电，旭东机械等上市公司的供应商名录。同步开始为火车站机务段完成车钩视觉检测系统</p>
              </div>
            </div>
          </li>
          <li class="time-item overflow">
            <div class="year left">2021</div>
            <div class="thing-list left">
              <div class="thing-item">
                <div class="point"></div>
                <p class="title">02月01日</p>
                <p class="desc">开发出全国第一台PCB check视觉检测系统，车架总成在线检测系统，全自主开发的AOI粒子检测系统，同年获得中国一汽合作供应商名录。</p>
              </div>
              <div class="thing-item">
                <div class="point"></div>
                <p class="title">至今</p>
                <p class="desc">...</p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div id="company-framework">
      <div class="framework-content">
        <ul class="left-title-content overflow">
          <li class="li-icon left"></li>
          <li class="li-title left">
            <p class="trans">COMPANY STRUCTURE</p>
            <p class="title">公司架构</p>
          </li>
        </ul>
        <div class="framework-img">
          <img
            src="@/assets/image/framework-img.png"
            alt=""
          >
        </div>
      </div>
    </div>
    <!-- <div id="company-team">
      <div class="team-content">
        <div class="title-content">
          <p class="trans">MANAGEMENT TEAM</p>
          <p class="title">管理团队</p>
        </div>
        <div class="photo-list overflow">
          <div class="photo-item left">
            <div class="photo-img">
              <img
                src="@/assets/image/"
                alt=""
              >
            </div>
            <div class="msg-card">
              <p class="title">
                <span class="name"></span>/创始人
              </p>
              <div class="desc-content">
                <p class="desc">优我科华CEO、主要创始人，全面负责公司组织发展建设、战略规划管理。在2017年创立优我科华前，创办过91ting音乐网。之后加入Google中国
                  ，任职AdSense小组大客户经理。2012年在江苏极限网络技术股份有限公司工作，作为创始人之一，任职CIO首席信息官。</p>
              </div>
            </div>
          </div>
          <div class="photo-item left">
            <div class="photo-img">
              <img
                src="@/assets/image/"
                alt=""
              >
            </div>
            <div class="msg-card">
              <p class="title">
                <span class="name"></span>/事业部总监
              </p>
              <div class="desc-content">
                <p class="desc">
                  优我科华营销服务事业部总监，主要负责平台业务规划、业务团队建设管理。2011年毕业于西安工业大学，2012年进入江苏极限网路技术股份有限公司，2015年担任极速平台总监，2017年加入优我科华。</p>
              </div>
            </div>
          </div>
          <div class="photo-item left">
            <div class="photo-img">
              <img
                src="@/assets/image/"
                alt=""
              >
            </div>
            <div class="msg-card">
              <p class="title">
                <span class="name"></span>/组织发展部 高级经理
              </p>
              <div class="desc-content">
                <p class="desc">
                    优我科华组织发展部HRM，主要负责HR六大板块及组织文化建设落地。2010年毕业于延安大学，毕业后加入世界500强企业冠捷科技集团，历任总助、HRM。2016年加入江苏极限网络技术股份有限公司，担任平台HRBP。于2018年加入优我科华。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>-->
    <div
      id="company-value"
      class="overflow"
    >
      <img
        class="bg-vision"
        src="@/assets/image/company-value.jpg"
        alt=""
      >
      <ul class="vision-content overflow">
        <li class="li-icon left"></li>
        <li class="li-title left">
          <p class="trans">ENTERPRISE VALUES</p>
          <p class="title">企业价值观</p>
        </li>
        <li class="li-desc left">
          <p class="title" style="margin-top: 0px;">客户第一</p>
          <p class="desc">始终以为客户创造价值为先</p>
          <p class="title">信任合作</p>
          <p class="desc">始终以尊重对方、彼此信任为建立合作的基础，相互成就最佳状态</p>
          <p class="title">拥抱变化、化茧成蝶</p>
          <p class="desc">打破成规、不断拥抱变化寻求突破，持续成长</p>
          <p class="title">积极行动</p>
          <p class="desc">以积极的方式参与并行动，先做到60分、再努力100分</p>
          <p class="title">诚信正直</p>
          <p class="desc">始终坚持做正确的事情，诚实正直，坦率待人</p>
        </li>
      </ul>
    </div>
    <div id="company-partner">
      <div class="partner-content">
        <div class="title-content">
          <p class="trans">COOPERATIVE PARTNER</p>
          <p class="title">合作伙伴</p>
        </div>
        <ul class="logo-list overflow">
          <li class="logo-item left"><img
            src="@/assets/image/partners/yiqi.png"
            alt=""
          ></li>
          <li class="logo-item left"><img
            src="@/assets/image/partners/tpv.png"
            alt=""
          ></li>
          <li class="logo-item left"><img
            src="@/assets/image/partners/zdjt.png"
            alt=""
          ></li>
          <li class="logo-item left"><img
            src="@/assets/image/partners/boe.png"
            alt=""
          ></li>
          <li class="logo-item left"><img
            src="@/assets/image/partners/sqzk.png"
            alt=""
          ></li>
          <li class="logo-item left"><img
            src="@/assets/image/partners/csot.png"
            alt=""
          ></li>
        </ul>
      </div>
    </div>
    <Footer/>
    <Top/>
  </div>
</template>

<script>
import Header from '@/components/Header/index.vue'
import Footer from '@/components/Footer/index.vue'
import Top from '@/components/Top/index.vue'
import $ from 'jquery'

export default {
  components: {'Header': Header, 'Footer': Footer, 'Top': Top},
  data() {
    return {
      navBar: false,
      isScroll: 542,
      isFixed: false,
      hide: -60
    }
  },
  watch: {
    $route(to) {
      this.autoScroll(to.query.href)
    }
  },
  mounted() {
    var OffsetTop = function getElementToPageTop(el) {
      return el.offset().top - $(window).scrollTop()
    }
    const _this = this
    const _href = _this.$route.query.href
    _this.autoScroll(_href)
    $(document).ready(function () {
      var p = 0, t = 0;
      $(window).scroll(function () {
        window.console.log(OffsetTop($('#company-introduce')))
        var _scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        var _head = document.getElementsByClassName('header-chunrk-class')[0],
          _nav = document.getElementById('second-nav');
        if (_head) {
          p = $(this).scrollTop();
          if (t < p) {
            //下滚
            var _val2 = 0
            if (_this.hide == -60) {
              var int2 = setInterval(function () {
                _val2 = _val2 - 1
                _this.hide = _val2
                _head.style.top = _val2 + 'px'
                if (_val2 <= -60) {
                  _this.hide = 0
                  clearInterval(int2)
                }
              }, 1)
            }
          } else {
            //上滚
            var _val = -60
            if (_this.hide == 0) {
              var int = setInterval(function () {
                _val = _val + 1
                _this.hide = _val
                _head.style.top = _val + 'px'
                if (_val >= 0) {
                  _this.hide = -60
                  clearInterval(int)
                }
              }, 1)
            }
          }
          if (_scrollTop >= 542) {
            _nav.style.cssText = "position:fixed;top:0px;z-index:99;"
          } else {
            _nav.style.cssText = "position:static;"
          }
          _this.handleScroll(_scrollTop)
          setTimeout(function () {
            t = p;
          }, 0)
        }


      })

    })

  },
  methods: {
    goto(_val) {
      const _this = this
      this.isScroll = _val
      window.scrollTo({
        top: _val,
        behavior: "smooth"
      });
      setTimeout(function () {
        _this.handleScroll(_val)
      }, 1000)
    },
    autoScroll(_href) {
      const _this = this
      if (_href) {
        window.scrollTo(0, _href)
        _this.isScroll = _href
      } else {
        window.scrollTo(0, 0)
      }
    },
    handleScroll(scrollTop) {
      var _list = $('.nav-item')
      if (scrollTop < 1010) {
        _list.removeClass('active')
        _list.eq(0).addClass('active')
      } else if (scrollTop >= 1010 && scrollTop < 1410) {
        _list.removeClass('active')
        _list.eq(1).addClass('active')
      } else if (scrollTop >= 1410 && scrollTop < 2675) {
        _list.removeClass('active')
        _list.eq(2).addClass('active')
      } else if (scrollTop >= 2675 && scrollTop < 3300) {
        _list.removeClass('active')
        _list.eq(3).addClass('active')
      } else if (scrollTop >= 3300 && scrollTop < 4040) {
        _list.removeClass('active')
        _list.eq(4).addClass('active')
      } else if (scrollTop >= 4040 && scrollTop < 4600) {
        _list.removeClass('active')
        _list.eq(5).addClass('active')
      } else {
        _list.removeClass('active')
        _list.eq(6).addClass('active')
      }
    }
  }
}

</script>
<style lang='scss' scoped>
$active: #40a9ff;
$width: 1200px;
$banner-height: 632px;
$font: 14px;
$trans: 0.25;
$opacity: 0.85;
$time-height: 110px;

.left-title-content {
  .li-icon {
    width: 5px;
    height: 60px;
    background: rgba(64, 169, 255, 1);
  }

  .li-title {
    margin-left: 24px;

    .trans {
      height: 18px;
      font-size: 14px;
      line-height: 18px;
    }

    .title {
      height: 36px;
      font-size: 30px;
      font-weight: 500;
      line-height: 36px;
      margin-top: 8px;
    }
  }
}

.fixed-yes {
  left: 0px;
  top: 0px;
  z-index: 999;
}

#second-nav {
  width: 100%;
  height: 49px;
  background: #ffffff;
  box-shadow: 0px -1px 1px 1px rgba(0, 0, 0, 0.5);

  .nav-content {
    width: $width + 30;
    margin: 0 auto;
    text-align: center;

    .nav-item {
      width: 106px;
      margin-left: 80px;
      padding: 14px 0px;
      cursor: pointer;
      text-decoration: none;
      height: 20px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.65);
      line-height: 20px;
    }

    .first {
      margin-left: 0px;
    }

    .active {
      color: $active;
      border-bottom: 1px solid $active;
    }
  }
}

#company-introduce {
  .introduce-content {
    padding: 120px 0px;
    width: $width;
    margin: 0 auto;

    .text-content {
      margin-top: 60px;

      .text {
        padding-top: 16px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(0, 0, 0, 0.65);
        line-height: 18px;
      }
    }
  }
}

#company-vision {
  width: 100%;
  height: 294;
  position: relative;

  .bg-vision {
    width: 100%;
    min-width: 1920px;
  }

  .vision-content {
    width: $width;
    margin: 0 auto;
    position: absolute;
    left: 50%;
    top: 0px;
    margin-left: -($width/2);
    color: rgba(255, 255, 255, 0.85);
    padding-top: 120px;

    .li-icon {
      width: 5px;
      height: 60px;
      background: rgba(64, 169, 255, 1);
    }

    .li-title {
      margin-left: 24px;

      .trans {
        height: 18px;
        font-size: 14px;
        line-height: 18px;
      }

      .title {
        margin-top: 8px;
        height: 36px;
        font-size: 30px;
        font-weight: 500;
        line-height: 36px;
      }
    }

    .li-desc {
      margin-left: 230px;

      .title {
        height: 30px;
        font-size: 24px;
        font-weight: 500;
        line-height: 30px;
        margin-bottom: 16px;
      }

      .desc {
        font-size: 14px;
        line-height: 27px;
      }
    }
  }
}

#develop {
  padding: 80px 0px;

  .de-content {
    width: $width;
    margin: 0 auto;

    .time-list {
      margin-top: 60px;

      .time-item {
        /* height: $time-height; */

        .year {
          text-align: right;
          color: $active;
          width: 290px;
          height: $time-height;
          padding-right: 35px;
          line-height: $time-height + 25;
          font-size: 38px;
        }

        .thing-list {
          font-size: 14px;

          .thing-item {
            height: $time-height;
            padding-left: 40px;
            border-left: 1px solid #e8e8e8;
            width: 830px;

            .point {
              display: inline-block;
              height: 6px;
              width: 6px;
              border: 1px solid $active;
              border-radius: 50%;
              float: left;
              margin-left: -45px;
              margin-top: 65px;
              background: #ffffff;
            }

            .title {
              color: $active;
              padding-top: 60px;
              /* line-height: 100px; */
            }

            .desc {
              margin-top: 10px;
              color: rgba(0, 0, 0, 0.65);
            }
          }
        }
      }
    }
  }
}

#company-framework {
  padding: 120px 0px 108px;
  background: rgba(248, 248, 248, 1);

  .framework-content {
    width: $width;
    margin: 0 auto;

    .framework-img {
      width: $width;
      height: 275px;
      margin-top: 60px;

      img {
        width: 100%;
      }
    }
  }
}

#company-team {
  padding: 120px 0px;

  .team-content {
    width: $width;
    margin: 0 auto;

    .photo-list {
      width: $width;
      height: 380px;
      margin-top: 60px;

      .photo-item {
        padding: 10px;
        height: 360px;

        .photo-img {
          height: 120px;
          margin-bottom: -60px;
          text-align: center;
        }

        .msg-card {
          width: 346px;
          padding: 90px 17px 40px;
          box-shadow: 0px 2px 20px 0px rgba(64, 169, 255, 0.2);
          border-radius: 10px;

          .title {
            height: 20px;
            font-size: 16px;
            line-height: 20px;
            color: rgba(0, 0, 0, 0.5);

            .name {
              height: 30px;
              font-size: 24px;
              font-weight: 500;
              color: $active;
              line-height: 30px;
              padding-right: 8px;
            }
          }

          .desc-content {
            height: 108px;

            .desc {
              margin-top: 36px;
              font-size: 14px;
              color: rgba(0, 0, 0, 0.65);
              line-height: 27px;
            }
          }
        }
      }
    }
  }
}

#company-value {
  width: 100%;
  height: 690px;
  position: relative;

  .bg-vision {
    width: 100%;
    min-width: 1920px;
  }

  .vision-content {
    width: $width;
    margin: 0 auto;
    position: absolute;
    left: 50%;
    top: 0px;
    margin-left: -($width/2);
    color: rgba(255, 255, 255, 0.85);
    padding-top: 120px;

    .li-icon {
      width: 5px;
      height: 60px;
      background: rgba(64, 169, 255, 1);
    }

    .li-title {
      margin-left: 24px;

      .trans {
        height: 18px;
        font-size: 14px;
        line-height: 18px;
      }

      .title {
        margin-top: 8px;
        height: 36px;
        font-size: 30px;
        font-weight: 500;
        line-height: 36px;
      }
    }

    .li-desc {
      margin-left: 234px;

      .title {
        height: 30px;
        font-size: 24px;
        font-weight: 500;
        line-height: 30px;
        margin-top: 40px;
      }

      .desc {
        height: 20px;
        font-size: 14px;
        line-height: 20px;
        margin-top: 8px;
      }
    }
  }
}

#company-partner {
  padding: 120px 0px;

  .partner-content {
    width: $width;
    margin: 0 auto;

    .logo-list {
      height: 190px;
      margin-top: 60px;

      .logo-item {
        height: 90px;
        width: 300px;
      }
    }
  }
}

#banner {
  width: 100%;
  /* height: 482px; */

  background-size: cover;
  background-repeat: no-repeat;

  img {
    width: 100%;
    height: 100%;
    border: 0;
    display: block;
  }
}

.title-content {
  text-align: center;

  .title {
    font-size: 30px;
    height: 36px;
    margin-top: 4px;
    line-height: 36px;
  }

  .icon {
    margin: 10px auto;
    height: 2px;
    width: 24px;
    background: $active;
  }

  .trans {
    font-size: $font;
    opacity: $trans;
  }
}
</style>
